export default __webpack_public_path__ + "static/5.Cornerstone-b1a42740d283057641cc8542cb0e43d6.png";